import { render, staticRenderFns } from "./contentDetail.vue?vue&type=template&id=4b905f86&scoped=true&"
import script from "./contentDetail.vue?vue&type=script&lang=js&"
export * from "./contentDetail.vue?vue&type=script&lang=js&"
import style0 from "./contentDetail.vue?vue&type=style&index=0&id=4b905f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b905f86",
  null
  
)

export default component.exports